import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import routes from "@/constants/routes";

const HeaderDesktop = (): JSX.Element => {
  const router = useRouter();

  return (
    <nav className={`relative z-50 w-full py-4 bg-white`}>
      <div className="flex items-center justify-between w-full justify-items-start px-16">
        <Link href="/" className="">
          <a className="relative w-10 h-9 lg:w-44 lg:h-12 flex">
            <Image
              src={"/shared/keyzy-horizontal-white.svg"}
              alt="keyzy logo"
              layout="fill"
              priority
            />
          </a>
        </Link>

        <div className="hidden md:flex justify-around w-auto px-4 grow justify-items-center items-center gap-4 lg:gap-6 ml-20">
          <Link href={routes.dashboard.root}>
            <a
              className={`text-lg font-bold ${
                router.pathname === routes.dashboard.root ? "text-black" : "text-grey-300"
              }  lg:inline-block`}
            >
              Dashboard
            </a>
          </Link>
          <Link href={routes.dashboard.documents}>
            <a
              className={`text-lg font-bold  ${
                router.pathname === routes.dashboard.documents ? "text-black" : "text-grey-300"
              } lg:inline-block`}
            >
              Documents
            </a>
          </Link>
          <Link href={routes.dashboard.howToGuides}>
            <a
              className={`text-lg font-bold  ${
                router.pathname === routes.dashboard.howToGuides ? "text-black" : "text-grey-300"
              } lg:inline-block`}
            >
              How to guides
            </a>
          </Link>
          <Link href={routes.dashboard.referral}>
            <a
              className={`text-lg font-bold  ${
                router.pathname === routes.dashboard.referral ? "text-black" : "text-grey-300"
              } lg:inline-block`}
            >
              Referral
            </a>
          </Link>
          <Link href={routes.dashboard.faq}>
            <a
              className={`text-lg font-bold  ${
                router.pathname === routes.dashboard.faq ? "text-black" : "text-grey-300"
              } lg:inline-block`}
            >
              FAQs
            </a>
          </Link>
        </div>

        <Link href={routes.dashboard.manageAccount}>
          <a className="text-lg font-bold text-black hidden md:flex w-auto">
            Your account{" "}
            <div className="hidden lg:flex lg:ml-3 ">
              <Image
                src="/icons/people.svg"
                alt="account"
                width={24}
                height={24}
                className="mb-[3px]"
              />
            </div>
          </a>
        </Link>
      </div>
    </nav>
  );
};

export default HeaderDesktop;
